import { IconButton, TextInput } from "@carbon6/c6-frontend-design";
import type { ChangeEvent, ReactNode } from "react";
import type { KeyValuePair } from "./submitWizardForm";
import styles from "./submitWizard.module.css";

// config override·resource extra 입력기. key-value 행 목록이다. 폼 모듈이 빌드할 때 빈 행을 버린다.
export function KeyValueEditor({
  pairs,
  onChange,
  keyPlaceholder = "키를 입력해 주세요.",
  valuePlaceholder = "값을 입력해 주세요.",
  ariaLabel,
}: {
  pairs: readonly KeyValuePair[];
  onChange: (next: KeyValuePair[]) => void;
  keyPlaceholder?: string;
  valuePlaceholder?: string;
  ariaLabel?: string;
}): ReactNode {
  const update = (index: number, patch: Partial<KeyValuePair>) => {
    onChange(pairs.map((pair, i) => (i === index ? { ...pair, ...patch } : pair)));
  };
  const remove = (index: number) => onChange(pairs.filter((_, i) => i !== index));
  const add = () => onChange([...pairs, { key: "", value: "" }]);

  return (
    <div className={styles.kvEditor} aria-label={ariaLabel}>
      {pairs.map((pair, index) => (
        // 행에 안정적인 id 가 없어서 index 키를 쓴다(추가는 배열 끝, 삭제는 필터라 순서가 유지된다).
        <div key={index} className={styles.kvRow}>
          <TextInput
            value={pair.key}
            placeholder={keyPlaceholder}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              update(index, { key: event.target.value })
            }
          />
          <TextInput
            value={pair.value}
            placeholder={valuePlaceholder}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              update(index, { value: event.target.value })
            }
          />
          <IconButton
            text="✕"
            variant="surface"
            className={styles.squareButton}
            aria-label="행 삭제"
            onClick={() => remove(index)}
          />
        </div>
      ))}
      <IconButton text="+ 추가" variant="surface" onClick={add} />
    </div>
  );
}
